export default "__VITE_ASSET__DPE_GBhP__"